/**
 * JWT.js
 * Written by: Alex Kasemir
 */

import userActions from '../../actions';

/**
 * Holds the JSON web token that authenticates the currently logged in user
 */

const jwt = (state = ``, action) => {
  switch (action.type) {
    case userActions.AUTHENTICATE_FACEBOOK_SUCCESS:
    case userActions.AUTHENTICATE_GMAIL_SUCCESS:
    case userActions.REFRESH_TOKEN_SUCCESS:
      return action.token;
    case userActions.LOGOUT_SUCCESS:
    case userActions.REMOVE_TOKEN_SUCCESS:
      return ``;
    default:
      return state;
  }
};

export default jwt;
